// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-scroll-component {
overflow: visible !important;
}

.register-events {
  width: 100%;
  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
  margin-bottom: 32px;
  margin-top: 20px !important;
  cursor: pointer;
}
.event-mobile {
  display: none;
}
.web-events-list {
  display: flex;
  align-items: center;
  width: 100%;
}
.event-details {
  width: 650px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.event-img {
  height: 100px;
  width: 100px;
  padding: 11px;
  margin-left: -11px;
}
.title {
  color: #68ad3f;
  font-weight: 500;
  font-size: 14px;
}

.event-name {
  font-size: 20px;
  color: #424242;
}
.reg-date {
  margin-bottom: 3px;
  color: #797979;
  font-size: 16px;
}
.reg-date-open{
  margin-bottom: 3px;
  color: #3f3f3f;
  font-size: 16px;
  opacity: 37%;
}
.reg-date-close {
  color: #fbb040;
  font-size: 14px;
  text-align: end;
}
.reg-name {
  text-align: end;
}
.registrationDetails {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 0 17px;
}


/* <---------------------------- media query for mpbile devices -------------------------------------> */
@media only screen and (min-width: 0px) and (max-width: 480px) {

  .register-events {
    padding: 20px 0px 20px 0px;
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
  }
  .register-events-web{
display:none !important;
  }
  .event-mobile {
    width: 100%;
    display: block;
  }
  .event-name {
    font-size: 12px;
  }
  .web-btn {
    display: none !important;
  }
  .event-mobile-div {
    display: flex;
    align-items: center;
    padding: 0px 20px 0px 20px;
  }
  .web-events-list {
    display: none;
  }
  .event-img {
    height: 50px;
    width: 50px;
    padding: 2px;
  }
  .reg-date, .reg-date-open {
    font-size: 12px !important;
    margin-top: 5px;
  }
  
  .reg-name {
    padding: 0px 20px 0px 20px;
  }
  .reg-close {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eaeaea;
    width: 100%;
    padding: 16px 20px 0px 20px;
  }
  .event-details {
    width: 100%;
  }
  .reg-date-mobile {
    font-size: 12px;
  }
  .reg-date-close {
    font-size: 11px;
    text-align: start;
  }
  .mobile-registration {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .title {
    font-size: 10px;
  }
  .mob-register-btn {
    width: 122px !important;
  }
}

/* <---------------------------- media query for mpbile devices landscape orientation -------------------------------------> */
@media only screen and (min-width: 481px) and (max-width: 767px) {

  .event-mobile {
    width: 100%;
    display: block;
  }
  .register-events,.register-events-web {
    padding: 20px 0px 20px 0px;
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
  }
  .event-name {
    font-size: 16px !important;
  }
  .web-btn {
    display: none !important;
  }
  .event-mobile-div {
    display: flex;
    align-items: center;
    padding: 0px 20px 0px 20px;
  }
  .web-events-list {
    display: none;
  }
  .event-img {
    height: 50px;
    width: 50px;
    padding: 2px;
  }
  .reg-date, .reg-date-open{
    font-size: 12px;
  }
  .reg-name {
    padding: 0px 20px 0px 20px;
  }
  .reg-close {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eaeaea;
    width: 100%;
    padding: 16px 20px 0px 20px;
  }
  .event-details {
    width: 100%;
  }
  .reg-date-mobile {
    font-size: 13px;
  }
  .reg-date-close {
    font-size: 12px;
  }
  .mobile-registration {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .title {
    font-size: 13px;
  }
  .mob-register-btn {
    width: 122px !important;
  }
}

/* <---------------------------- media query for ipad devices -------------------------------------> */
@media only screen and (min-width: 768px) and (max-width: 980px) {
  .event-details {
    width: 257px !important;
  }
  .event-name {
    font-size: 15px;
  }
  .reg-date, .reg-date-open {
    font-size: 13px !important ;
  }
  .reg-date-close {
    font-size: 9px;
  }
  .title {
    font-size: 12px;
  }
}
/* <---------------------------- media query for ipad pro devices -------------------------------------> */
@media only screen and (min-width: 981px) and (max-width: 1190px) {
  .event-details {
    width: 444px;
  }
  .event-name {
    font-size: 16px;
  }

  .registration-div {
    flex-grow: 1;
  }
  .create-event h2 {
    font-size: 33px !important;
  }
}
.reg-date{
 font-size:15px;
}
 .reg-date-open {
  font-size: 14px;
}
@media only screen and (min-width: 1190px) and (max-width: 1400px) {
  .event-details {
    width: 605px;
  }
  .cardspacing {
    padding: 30px 0px !important;
  }
}
/* <---------------------------- media query for large screens -------------------------------------> */
@media screen and (min-width: 1200px) {
  .event-details {
    flex-grow: 1;
  }
  .register-events {
    padding: 15px 40px;
  }
  .register-eventsEdit{
    padding: 10px 40px;
  }
  .cardspacing {
    padding: 0px 0px 46px 0px !important;
  }
  .devincornell {
    padding: 0px 0px 27px 0px !important;
  }
  .cardSection{
    padding: 35px 0px !important;
  }
  
}

@media screen and (min-width: 1900px) {
  .devincornell {
    padding: 9px 0px 89px 0px !important;
  }
  .cardspacing {
    padding:  0px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Card/style.css"],"names":[],"mappings":"AAAA;AACA,4BAA4B;AAC5B;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;;AAGA,wGAAwG;AACxG;;EAEE;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;EACA;AACF,uBAAuB;EACrB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,8HAA8H;AAC9H;;EAEE;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,sGAAsG;AACtG;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF;AACA,0GAA0G;AAC1G;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;CACC,cAAc;AACf;CACC;EACC,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;AACF;AACA,uGAAuG;AACvG;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,4BAA4B;EAC9B;;AAEF;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".infinite-scroll-component {\noverflow: visible !important;\n}\n\n.register-events {\n  width: 100%;\n  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 20px;\n  margin-bottom: 32px;\n  margin-top: 20px !important;\n  cursor: pointer;\n}\n.event-mobile {\n  display: none;\n}\n.web-events-list {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.event-details {\n  width: 650px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n.event-img {\n  height: 100px;\n  width: 100px;\n  padding: 11px;\n  margin-left: -11px;\n}\n.title {\n  color: #68ad3f;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.event-name {\n  font-size: 20px;\n  color: #424242;\n}\n.reg-date {\n  margin-bottom: 3px;\n  color: #797979;\n  font-size: 16px;\n}\n.reg-date-open{\n  margin-bottom: 3px;\n  color: #3f3f3f;\n  font-size: 16px;\n  opacity: 37%;\n}\n.reg-date-close {\n  color: #fbb040;\n  font-size: 14px;\n  text-align: end;\n}\n.reg-name {\n  text-align: end;\n}\n.registrationDetails {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0 17px;\n}\n\n\n/* <---------------------------- media query for mpbile devices -------------------------------------> */\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n\n  .register-events {\n    padding: 20px 0px 20px 0px;\n    align-items: flex-start;\n    flex-direction: column;\n    height: 100%;\n  }\n  .register-events-web{\ndisplay:none !important;\n  }\n  .event-mobile {\n    width: 100%;\n    display: block;\n  }\n  .event-name {\n    font-size: 12px;\n  }\n  .web-btn {\n    display: none !important;\n  }\n  .event-mobile-div {\n    display: flex;\n    align-items: center;\n    padding: 0px 20px 0px 20px;\n  }\n  .web-events-list {\n    display: none;\n  }\n  .event-img {\n    height: 50px;\n    width: 50px;\n    padding: 2px;\n  }\n  .reg-date, .reg-date-open {\n    font-size: 12px !important;\n    margin-top: 5px;\n  }\n  \n  .reg-name {\n    padding: 0px 20px 0px 20px;\n  }\n  .reg-close {\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #eaeaea;\n    width: 100%;\n    padding: 16px 20px 0px 20px;\n  }\n  .event-details {\n    width: 100%;\n  }\n  .reg-date-mobile {\n    font-size: 12px;\n  }\n  .reg-date-close {\n    font-size: 11px;\n    text-align: start;\n  }\n  .mobile-registration {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n  .title {\n    font-size: 10px;\n  }\n  .mob-register-btn {\n    width: 122px !important;\n  }\n}\n\n/* <---------------------------- media query for mpbile devices landscape orientation -------------------------------------> */\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n\n  .event-mobile {\n    width: 100%;\n    display: block;\n  }\n  .register-events,.register-events-web {\n    padding: 20px 0px 20px 0px;\n    align-items: flex-start;\n    flex-direction: column;\n    height: 100%;\n  }\n  .event-name {\n    font-size: 16px !important;\n  }\n  .web-btn {\n    display: none !important;\n  }\n  .event-mobile-div {\n    display: flex;\n    align-items: center;\n    padding: 0px 20px 0px 20px;\n  }\n  .web-events-list {\n    display: none;\n  }\n  .event-img {\n    height: 50px;\n    width: 50px;\n    padding: 2px;\n  }\n  .reg-date, .reg-date-open{\n    font-size: 12px;\n  }\n  .reg-name {\n    padding: 0px 20px 0px 20px;\n  }\n  .reg-close {\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #eaeaea;\n    width: 100%;\n    padding: 16px 20px 0px 20px;\n  }\n  .event-details {\n    width: 100%;\n  }\n  .reg-date-mobile {\n    font-size: 13px;\n  }\n  .reg-date-close {\n    font-size: 12px;\n  }\n  .mobile-registration {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n  .title {\n    font-size: 13px;\n  }\n  .mob-register-btn {\n    width: 122px !important;\n  }\n}\n\n/* <---------------------------- media query for ipad devices -------------------------------------> */\n@media only screen and (min-width: 768px) and (max-width: 980px) {\n  .event-details {\n    width: 257px !important;\n  }\n  .event-name {\n    font-size: 15px;\n  }\n  .reg-date, .reg-date-open {\n    font-size: 13px !important ;\n  }\n  .reg-date-close {\n    font-size: 9px;\n  }\n  .title {\n    font-size: 12px;\n  }\n}\n/* <---------------------------- media query for ipad pro devices -------------------------------------> */\n@media only screen and (min-width: 981px) and (max-width: 1190px) {\n  .event-details {\n    width: 444px;\n  }\n  .event-name {\n    font-size: 16px;\n  }\n\n  .registration-div {\n    flex-grow: 1;\n  }\n  .create-event h2 {\n    font-size: 33px !important;\n  }\n}\n.reg-date{\n font-size:15px;\n}\n .reg-date-open {\n  font-size: 14px;\n}\n@media only screen and (min-width: 1190px) and (max-width: 1400px) {\n  .event-details {\n    width: 605px;\n  }\n  .cardspacing {\n    padding: 30px 0px !important;\n  }\n}\n/* <---------------------------- media query for large screens -------------------------------------> */\n@media screen and (min-width: 1200px) {\n  .event-details {\n    flex-grow: 1;\n  }\n  .register-events {\n    padding: 15px 40px;\n  }\n  .register-eventsEdit{\n    padding: 10px 40px;\n  }\n  .cardspacing {\n    padding: 0px 0px 46px 0px !important;\n  }\n  .devincornell {\n    padding: 0px 0px 27px 0px !important;\n  }\n  .cardSection{\n    padding: 35px 0px !important;\n  }\n  \n}\n\n@media screen and (min-width: 1900px) {\n  .devincornell {\n    padding: 9px 0px 89px 0px !important;\n  }\n  .cardspacing {\n    padding:  0px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
